import React from 'react';
import { roundInt, roundFloat } from 'helpers/helpers';
import SimpleCard from './SimpleCard';
import './SmallInfoTable.css';

const SmallInfoTable = ({ title, columns, data, className }) => {
  // Columnas de la derecha son las unicas que tienen titulo
  const rightColumns = columns.filter((col) => col.title);
  const formatValue = (value) => {
    // If value is a React element, return it as-is
    if (React.isValidElement(value)) {
      return value;
    }
    if (value !== undefined && !Number.isNaN(value)) {
      return Number.isInteger(value) ? roundInt(value) : roundFloat(value);
    }
    return value;
  };
  return (
    <>
      <SimpleCard title="Cúmulos deudor" className={`small-info-table-container ${className}`}>
        <table className="small-info-table">
          <tbody>
            {rightColumns.length > 0 && (
              <tr className="column-headers">
                {/* eslint-disable-next-line */}
                <td> </td>
                {rightColumns.map((col, index) => (
                  <td key={index}>
                    <div className="column-header" style={{ backgroundColor: col.color }}>
                      {col.title}
                    </div>
                  </td>
                ))}
              </tr>
            )}
            {data.map((row, rowIndex) => {
              // Render separator row
              if (row.separator) {
                return (
                  <tr key={rowIndex}>
                    <td colSpan={columns.length} style={{ padding: '12px 0' }}>
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          textAlign: 'center',
                          color: '#6c757d',
                          fontSize: '13px',
                          fontWeight: 500
                        }}
                      >
                        <div style={{ flex: 1, borderBottom: '1px solid #e5e7eb' }}> </div>
                      
                        <span style={{ padding: '0 12px' }}>
                          {row.separator}
                        </span>
                      
                        <div style={{ flex: 1, borderBottom: '1px solid #e5e7eb' }}> </div>
                      </div>
                    </td>
                  </tr>
                );
              }
            
              // Normal row
              return (
                <tr key={rowIndex}>
                  {columns.map((col, colIndex) =>
                    colIndex === 0 ? (
                      <td key={colIndex} className="label">
                        {row[col.accessor]}
                      </td>
                    ) : (
                      <td key={colIndex} className="value">
                        <span style={{ color: col.color || 'currentcolor' }}>
                          {formatValue(row[col.accessor]) || '-'}
                        </span>
                      </td>
                    )
                  )}
                </tr>
              );
            })}
          </tbody>
        </table>
      </SimpleCard>
    </>
  );
};
SmallInfoTable.propTypes = [];
export default SmallInfoTable;
